import { css } from '@emotion/react'
import somAlertaUrl from 'audio/chamada-painel.mp3'
import { Button, HFlow, Icon, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { useLocalStorageState } from 'hooks/useStorage'
import { useCallback, useRef, useState } from 'react'

import { HeaderPainelChamada } from './components/HeaderPainelChamada'
import { PainelScaledLayout } from './components/PainelScaledLayout'
import { CHAMADA_PAINEL_STORAGE_KEYS } from './constants-chamadaPainel'
import { CredenciaisChamadaPainel } from './model-chamadaPainel'
import { PainelChamadasView } from './PainelChamadasView'
import { PainelPareamentoView } from './PainelPareamentoView'

export const PainelChamadasRootView = () => {
  const audioRef = useRef<HTMLAudioElement>(null)

  const [credenciais, setCredenciais] = useLocalStorageState<CredenciaisChamadaPainel | null>(
    CHAMADA_PAINEL_STORAGE_KEYS.CREDENCIAIS
  )
  const [iniciado, setIniciado] = useState<boolean>(false)
  const theme = useTheme()

  const handlePareado = useCallback(
    (tokenAcesso: string, uuidDispositivo: string) => {
      setCredenciais({ tokenAcesso, uuidDispositivo })
    },
    [setCredenciais]
  )

  const handleIniciarPainel = useCallback(() => {
    const audioElement = audioRef.current
    if (audioElement) {
      audioElement.muted = true
      audioElement
        .play()
        .then(() => {
          audioElement.pause()
          audioElement.currentTime = 0
        })
        .catch(() => {})
        .finally(() => {
          audioElement.muted = false
        })
    }

    setIniciado(true)
  }, [])

  const styles = createStyles(theme)

  return (
    <PainelScaledLayout>
      {!credenciais ? (
        <PainelPareamentoView onPareado={handlePareado} />
      ) : (
        <>
          <audio ref={audioRef} src={somAlertaUrl} preload='auto' css={styles.audioElement} />
          {!iniciado ? (
            <div css={styles.startScreenWrapper}>
              <HeaderPainelChamada variant='light' />

              <VFlow style={styles.startScreenContentArea} vSpacing={2.5}>
                <VFlow vSpacing={0.5} style={styles.startScreenText}>
                  <Text variant='h1' color='inherit'>
                    Dispositivo conectado
                  </Text>
                  <Text variant='h3' fontWeight='normal' color='inherit' style={styles.startScreenText}>
                    O dispositivo está conectado com o PEC, clique no botão abaixo para iniciar o painel de chamadas.
                  </Text>
                </VFlow>

                <Button kind='primary' onClick={handleIniciarPainel}>
                  <HFlow hSpacing={0.5} alignItems='center'>
                    <Icon icon='playOutline' />
                    Iniciar painel de chamadas
                  </HFlow>
                </Button>
              </VFlow>
            </div>
          ) : (
            <PainelChamadasView
              tokenAcesso={credenciais.tokenAcesso}
              uuidDispositivo={credenciais.uuidDispositivo}
              audioRef={audioRef}
            />
          )}
        </>
      )}
    </PainelScaledLayout>
  )
}

const createStyles = (theme: Theme) => {
  return {
    audioElement: css`
      display: none;
    `,
    startScreenWrapper: css`
      flex: 1;
      background-color: ${theme.pallete.gray.c90};
      color: ${theme.pallete.primary.c30};
      padding: 2rem 2.5rem 2.625rem;
      display: flex;
      flex-direction: column;
    `,
    startScreenContentArea: css`
      flex-grow: 1;
      justify-content: center;
      align-items: center;
    `,
    startScreenText: css`
      text-align: center;
      color: ${theme.pallete.gray.c10};
    `,
  }
}
